module.exports = __webpack_public_path__ + "img/doctor1.3b0e8b06.png";